/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { Box, TextField, Theme, createTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { isDisabled } from "@testing-library/user-event/dist/utils";
interface SearchPlaceHolderMessage {
  placeHolderMessage?: string;
  value: any;
  isDisabled?: boolean;
  onChange(event: any): any;
}

export default function QuickSearchToolbar(props: SearchPlaceHolderMessage) {
  return (
    <Box
      sx={{
        width: "auto",
        margin: "0.2rem",
      }}
    >
      <TextField
        variant="standard"
        disabled={props.isDisabled ? true : false}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeHolderMessage}
        sx={{
          background: "#505050",
          boxShadow: "inset 1px 1px 1px rgba(0, 0, 0, 0.3)",
          borderRadius: "4px",
          fontWeight: 500,
          minWidth: "20px",
          margin: "0px",
          fontSize: "10rem",
          "& .MuiInputBase-root": {
            fontSize: "1.1rem",
            height: "4vh",
            width: "auto",
            paddingRight: "5vw",
            fontStyle: "Itallic",
          },
          "& .MuiFormControl-root": {
            fontSize: "0.9rem",
          },
          "&. MuiTextField-root": {
            fontSize: "10rem !important",
          },
        }}
        InputProps={{
          startAdornment: (
            <SearchIcon
              fontSize="small"
              style={{
                marginRight: ".5vh",
                fontFamily: "Honeywell Sans Web",
                marginLeft: ".5vh",
                verticalAlign: "centre",
                fontSize: "1.1rem",
              }}
            />
          ),
        }}
      />
    </Box>
  );
}
